export default __webpack_public_path__ + "static/media/330_dummy2016-immobilien01-de.1ae2c71a.png";